import { render } from "./Index.vue?vue&type=template&id=9c251ba0"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
script.render = render

export default script